import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";
import { useEditorContext } from "features/editor/context/editor";
import { Loading } from "@components";
import { SimilarTranslationItem } from "features/editor/components/panels/SimilarTranslationItem";
import { useFetchSimilarTranslationsInProject } from "features/workspaces/hooks/useFetchSimilarTranslationsInProject";
import type { ISimilarTranslationItemsFetchParams } from "features/workspaces/types";

export const SimilarTranslationInProject = ({
  onCopyClick,
  isLoading,
  setIsLoading,
}: {
  onCopyClick: any;
  isLoading: boolean;
  setIsLoading: any;
}) => {
  const { fileId, fileLabel } = useParams() as unknown as { fileId: number; fileLabel: string };
  const { activeItemIndex, list } = useEditorContext();
  const data = list.items[activeItemIndex!] ?? {};

  const [fetchParams, setFetchParams] = useState<ISimilarTranslationItemsFetchParams>({
    fileId: String(fileId),
    searchOriginal: data.original?.text,
  });

  useEffect(() => {
    const text = data.original?.text;

    setFetchParams(prev => ({
      ...prev,
      searchOriginal: text,
    }));
  }, [data]);

  // Fetch translation items
  const { similarTranslations } = useFetchSimilarTranslationsInProject(
    fetchParams,
    {
      idInFile: data.original?.idInFile,
      fileName: fileLabel,
    },
    setIsLoading,
  );

  return (
    <>
      {isLoading && <Loading className="b-loading--tiny" />}
      {!isLoading && similarTranslations?.length
        ? similarTranslations.map(item => (
            <SimilarTranslationItem
              text={item.text}
              fileName={item.fileName}
              groupName={item.groupName}
              idInFile={item.idInFile}
              originalText={data.original.text}
              key={item.fileName + item.groupName + item.idInFile}
              onCopyClick={onCopyClick}
            />
          ))
        : !isLoading && <Box>No similar translations found</Box>}
    </>
  );
};
